<template>
  <div>
    <div v-if="!abuseAdded.show">
      <h5>You are reporting the <em>{{ideaTitle}}</em> idea</h5>
      <div class="form-group">
        <label for="abuseReport">Report abuse</label>
        <textarea v-model="abuseReport" class="form-control" id="abuseReport" rows="5" placeholder="Enter your reasons for reporting this idea"></textarea>
        <small class="form-text text-muted">Include the reason/s you are reporting this idea</small>
      </div>
      <button type="button" class="btn btn-primary" :disabled="abuseReport.length === 0" v-on:click="addAbuseReport()">Submit abuse report</button>
    </div>
    <b-alert v-if="abuseAdded.show" show :variant="abuseAdded.variant">
      {{abuseAdded.message}}
    </b-alert>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import { mapGetters } from 'vuex'
export default {
  props: [
    'ideaTitle',
    'ideaId'
  ],
  data () {
    return {
      abuseReport: '',
      abuseAdded: ''
    }
  },
  computed: {
    ...mapGetters([
      'getProfileDetails'
    ])
  },
  methods: {
    emailAbuseReport: function (abuseID) {
      var emailAbuseReport = {
        method: 'POST',
        data: {
          to: 'thinktank@multichoice.co.za',
          subject: this.getProfileDetails.name + ' reported ' + this.ideaTitle + ' for abuse',
          message: '<h1>' + this.getProfileDetails.name +
          ' reported ' + this.ideaTitle + ' for abuse.</h1> <strong>Abuse report:</strong><br>' +
          this.abuseReport + '<br> <a href="' + WordpressRestURI.frontEndDomain + 'abuse-report/' + abuseID + '">View abuse report and idea that was reported</a>'
        },
        json: true
      }

      WordpressRestAPI.sendEmail(emailAbuseReport)
        .then(function (response) {
          console.log(response.data)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    addAbuseReport: function () {
      var self = this
      var createAbuseReport = {
        method: 'POST',
        data: {
          title: this.getProfileDetails.name + ' reported ' + this.ideaTitle + ' for abuse',
          idea_post_id_report_abuse: this.ideaId,
          content: this.abuseReport,
          status: 'publish'
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(createAbuseReport, 'abuse_report')
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          self.emailAbuseReport(response.data.id)
          self.abuseAdded = {show: true, message: 'Your abuse report has been sent', variant: 'success'}
        })
        .catch(function (e) {
          console.error(e)
          self.abuseAdded = {show: true, message: 'Oops, there was an error sending your abuse report', variant: 'danger'}
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportAbuse.vue